export const ordTypeList = [
  { value: 1, label: 'TRLT_UI-NORMAL' },
  { value: 2, label: 'TRLT_UI-STOP' },
];

const priceTypeList = [
  { value: 1, label: 'TRLT_UI-MARKET' },
  { value: 2, label: 'TRLT_UI-PRICE' },
];

export const fundsOrdTypeList = [
  { value: 3, label: 'TRLT_UI-QUANTITY' },
  { value: 1, label: 'TRLT_UI-AMOUNT' },
];

export const RESCUE_ORD_TYPES = fundsOrdTypeList.filter(
  (ordType) => ordType.value === 3,
);

export const getAvailableFundsOrdTypes = (subscriptionType) => {
  if (subscriptionType === 'U') return RESCUE_ORD_TYPES;

  if (subscriptionType === 'A')
    return fundsOrdTypeList.filter((ordType) => ordType.value === 1);

  if (subscriptionType === 'B') return fundsOrdTypeList;

  return [];
};

export const getAvailableOrdTypes = (
  orderPossibilities,
  selectedPriceType,
  setState,
) => {
  const normal = { ...ordTypeList[0], show: true };
  const stop = { ...ordTypeList[1], show: true };
  let availableOptions = [];

  if (selectedPriceType) {
    if (orderPossibilities.includes(selectedPriceType === 1 ? '1' : '2')) {
      availableOptions.push(normal);
    } else {
      availableOptions.push({ ...normal, show: false });
    }

    if (orderPossibilities.includes(selectedPriceType === 1 ? '3' : '4')) {
      availableOptions.push(stop);
    } else {
      availableOptions.push({ ...stop, show: false });
    }
  } else {
    availableOptions = orderPossibilities.reduce((acc, ord) => {
      if (ord === '1' || ord === '2') {
        const elAlreadyAdded = acc.find((el) => el.value === normal.value);
        if (!elAlreadyAdded) acc.push(normal);
      } else {
        const elAlreadyAdded = acc.find((el) => el.value === stop.value);
        if (!elAlreadyAdded) acc.push(stop);
      }

      return acc;
    }, []);
  }

  if (setState) setState(availableOptions);

  return availableOptions;
};

export const getAvailablePriceTypes = (
  orderPossibilities,
  selectedOrdType,
  setState,
) => {
  const market = { ...priceTypeList[0], show: true };
  const price = { ...priceTypeList[1], show: true };
  const currentOrdType =
    selectedOrdType || getAvailableOrdTypes(orderPossibilities)[0]?.value;
  const availableOptions = [];

  if (currentOrdType) {
    if (orderPossibilities.includes(currentOrdType === 1 ? '2' : '4')) {
      availableOptions.push(price);
    } else {
      availableOptions.push({ ...price, show: false });
    }

    if (orderPossibilities.includes(currentOrdType === 1 ? '1' : '3')) {
      availableOptions.push(market);
    } else {
      availableOptions.push({ ...market, show: false });
    }
  }

  if (setState) setState(availableOptions);

  return availableOptions;
};

export const operations = [
  { value: 1, label: 'TRLT_UI-PURCHASE', market: 'stockExchange' },
  { value: 2, label: 'TRLT_UI-SALE', market: 'stockExchange' },
  { value: 'D', label: 'TRLT_UI-SUBSCRIPTION', market: 'funds' },
  { value: 'E', label: 'TRLT_UI-RESCUE', market: 'funds' },
];
